type ProcessHeaderProps = {   
  title: string;
  pronoun?: string;
}

export function ProcessHeader({ title, pronoun = "os" }: ProcessHeaderProps) {
  return (
    <div className="py-2 py-sm-3">
      <h4 className="pt-0 header-title text-dark fw-bold fs-5 fs-sm-4 mb-2 mb-sm-3">
        Lista de {title}
      </h4>
      <p className="text-dark text-opacity-75 fs-7 fs-sm-6 mb-0 lh-base">
        {pronoun === "a"
          ? "Aqui são listadas todas as suas "
          : "Aqui são listados todos os seus "}
        {title.toLowerCase()}
      </p>
    </div>
  );
}
